import React from 'react';

import Button from 'ui/Button';
import Dialog from 'ui/Dialog';
import Icon from 'ui/Icon';

type Props = {
  open: boolean;
  isLoading: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

// TODO: Rename to DeleteDiagramDialog
const DeleteDiagramModal: React.FC<Props> = ({
  open,
  isLoading,
  onClose,
  onConfirm,
}) => {
  return (
    <Dialog.Root role="alertdialog" open={open} onOpenChange={onClose}>
      {/* This diagram might float above other diagrams so we bump its zIndex */}
      <Dialog.Content zIndex="popover">
        <Dialog.Header fontSize="lg" fontWeight="bold">
          <Icon fontSize="md" icon="trash-can-regular" mr={2} /> Delete diagram
        </Dialog.Header>
        <Dialog.Body>
          Are you sure you want to delete this diagram? You can't undo this
          action afterwards.
        </Dialog.Body>
        <Dialog.Footer>
          <Button variant="primary-ghost" onClick={onClose}>
            Cancel
          </Button>
          <Button
            variant="danger-solid"
            loading={isLoading}
            onClick={onConfirm}
          >
            Delete
          </Button>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog.Root>
  );
};

export default DeleteDiagramModal;
